export default {
	methods: {
		showInvalidFormMessage (msg) {
			this.$store.commit('ui/showNotification', {
				notification: msg || 'Please make sure you\'ve supplied the correct information above and try again.'
			});
		}
	}
};
